// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6458":"82688605","7562":"6302e0c7","8514":"6a21abd8","8607":"fee5ae8b"}[chunkId] + ".chunk.css";
};